import { axiosPrivate } from '@api/ApiHelper/axiosPrivate';

export default {
    // `manual`: el botón "reenviar" de la lista de pedidos. El server lo usa para
    // saltarse el apagado de "ventas del POS" (nunca el general). Si el aviso
    // está apagado responde `{ skipped }` en vez de un mensaje.
    async sendOrderPaid(orderId: string, manual: boolean = false): Promise<any> {
        try {
            return await axiosPrivate.post('/twilio/sendOrderPaid', { orderId, manual });
        } catch (error) {
            console.error('sendOrderPaid:', error);
        }
    },
    async sendOrderPaidAdmin(orderId: string): Promise<any> {
        try {
            return await axiosPrivate.post('/twilio/sendOrderPaidAdmin', { orderId });
        } catch (error) {
            console.error('sendOrderPaidAdmin:', error);
        }
    },
    async sendOrderRoute(orderId: string): Promise<any> {
        try {
            return await axiosPrivate.post('/twilio/sendOrderRoute', { orderId });
        } catch (error) {
            console.error('sendOrderRoute:', error);
        }
    },
    async sendOrderCompletedReview(orderId: string): Promise<any> {
        try {
            return await axiosPrivate.post('/twilio/sendOrderCompletedReview', { orderId });
        } catch (error) {
            console.error('sendOrderCompletedReview:', error);
        }
    }
};
